import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { formatGBP } from "../../leak detection/helper/helperFunctions";

// const formatAmount = (amount: string): string => {
//   if (!amount || amount.trim() === ",") return "0";

//   // Trim spaces and remove leading/trailing commas
//   const cleanedAmount = amount.trim().replace(/^,|,$/g, "").trim();

//   return cleanedAmount;
// };

const handleShowAmountInGBP = (rowData: any, type: string = "") => {
  return rowData
    .split(",")
    .map(
      (joinedAmount: any, index: number) =>
        `${
          index === 0 ? joinedAmount.slice(0, 1) : joinedAmount.slice(1, 2)
        } ${formatGBP(joinedAmount.trim().slice(1))}`
    )
    .join(", ");
};

const formatAmount = (amount: string) => {
  const trimmedAmount = amount.trim();

  if (trimmedAmount === ",") {
    return "0";
  }

  // If the amount has a valid currency format (like "€ 258 , £ 822"), return as is.
  if (trimmedAmount.match(/^[€£$]\s*\d+(?:\s*,\s*[€£$]\s*\d+)*$/)) {
    return trimmedAmount;
  }

  // Handle cases where amount starts or ends with ","
  return handleShowAmountInGBP(trimmedAmount.replace(/^,\s*|\s*,\s*$/g, ""));
};

const PieChartsTable = ({ dashBoardData, userType, showAnimation }: any) => {
  const pendingRejectColumns: ColumnOption[] = [
    { field: "displayname", header: "User", visible: true },
    {
      field: `${
        userType === "invoiceCreatedBy" ? "createdBycount" : "enteredBycount"
      }`,
      header: `${
        userType === "invoiceCreatedBy"
          ? "Created Invoices"
          : "Entered Invoices"
      }`,
      visible: true,
    },
    {
      field: "amount",
      header: "Total Amount",
      visible: true,
      body: (rowData: any) => formatAmount(rowData.amount), // Apply formatting
    },
  ];

  return (
    <div className={`${showAnimation ? "flipRightToLeft" : ""}`}>
      <DataTableComponent
        rowData={dashBoardData && dashBoardData[userType]}
        columns={pendingRejectColumns}
      />
    </div>
  );
};

export default PieChartsTable;
